module.exports = __webpack_public_path__ + "static/media/VERFID_BLUE_PAW_WITH_TM_2.0825c144.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/VERFID_BLUE_PAW_WITH_TM_2.PNG
// module id = 371
// module chunks = 0